let router;

if (process.env.VUE_APP_REGION === 'US') {
    router = require('@/router/us-router').default;
} else {
    router = require('@/router/au-router').default;
}

export default router;